import { WorkflowType } from 'shared/types/workflow';
import { formatWorkflowTypeString } from 'shared/utils/api/mappers/workflowMapper';

export const SEARCH_FILTER_KEY = 'name';
export const STATUS_FILTER_KEY = 'status';
export const TYPE_FILTER_KEY = 'type';

// For the select, create human readable options for the enum values
export const WORKFLOW_TYPE_SELECT_OPTIONS = Object.values(WorkflowType)
.filter(type => type !== WorkflowType.BLANK)
.map(type => ({
    name: type,
    label: formatWorkflowTypeString(type),
}));